import { render } from "./SettingsPanelManual.vue?vue&type=template&id=195f534d"
import script from "./SettingsPanelManual.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelManual.vue?vue&type=script&lang=ts"
script.render = render

export default script